import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DisplayComponent from '../BaseComponents/DisplayComponent';
import { universalActiveHtml } from '../../../utils/index';
import LazyLoad from 'react-lazyload';
import { withRouter } from 'react-router-dom';

import './Picture.module.css';

import * as breakpoints from '../breakpoints.json';

class Picture extends PureComponent {
  render() {
    let { smallImage, mediumImage, largeImage } = this.props;
    const {
      alt,
      caption,
      title,
      width,
      height,
      classes,
      styles,
      imageStyles,
      styleNames,
      fullBleed,
      location
    } = this.props;
    if (typeof largeImage !== 'object') {
      largeImage = { url: largeImage };
    }
    if (!mediumImage) {
      mediumImage = largeImage;
    }
    if (!smallImage) {
      smallImage = mediumImage;
    }
    const sources = [
      {
        key: `lg-${largeImage.url}`,
        srcSet: largeImage.url,
        media: breakpoints.lg
      },
      {
        key: `md-${largeImage.url}`,
        srcSet: mediumImage.url,
        media: breakpoints.md
      },
      {
        key: `sm-${largeImage.url}`,
        srcSet: smallImage.url,
        media: breakpoints.sm
      }
    ];
    const image = (
      <picture
        styleName={classNames(styleNames, fullBleed ? 'full-bleed' : '')}
        className={classes}
        style={styles}
      >
        {sources.map(s => (
          <source
            srcSet={s.srcSet}
            key={s.key}
            media={s.media}
            styleName="image"
            width={width}
            height={height}
          />
        ))}
        <img
          alt={alt || ''}
          caption={caption}
          title={title}
          src={smallImage.url}
          styleName="image"
          style={imageStyles}
          width={width}
          height={height}
          role={alt ? null : 'presentation'}
        />
      </picture>
    );
    const lazyimage =
      location.hash === '' || location.hash === '#' ? (
        <LazyLoad offset={100}>{image}</LazyLoad>
      ) : (
        image
      );
    return (
      <Fragment>
        {lazyimage}
        {caption && (
          <p styleName="caption">{universalActiveHtml(caption, {})}</p>
        )}
      </Fragment>
    );
  }
}

Picture.propTypes = {
  alt: PropTypes.string,
  caption: PropTypes.string,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  smallImage: PropTypes.object,
  mediumImage: PropTypes.object,
  largeImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  styleNames: PropTypes.array,
  classes: PropTypes.any,
  styles: PropTypes.object,
  imageStyles: PropTypes.object,
  fullBleed: PropTypes.bool
};

export default withRouter(DisplayComponent(Picture));
